/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * A cancelled session stays on the calendar, shown as such and not bookable
 */
export enum HubCalendarEntryStatus {
  available = 'available',
  full = 'full',
  cancelled = 'cancelled'
}
